import {GET_ALL_GL_ACCOUNT_NOTES, ASSOCIATE_GL_ACCOUNT_NOTE} from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes, reducerOperations} from '../../util/uiconstants';

export default function glAccountsNotesReducer(state = initialstate.glAccountNotes, action) {
	let newState = _.cloneDeep(state);
	switch (action.type) {
		case GET_ALL_GL_ACCOUNT_NOTES:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return action.response;
			}
			return state;

		case ASSOCIATE_GL_ACCOUNT_NOTE:
			if (state.data && !action.error) {
				if (action.payload.operation === reducerOperations.Add) {
					const newTagReference = {
						entityId: action.payload.entityId,
						entityUIId: action.payload.entityUIId
					};
					let tagList = newState.data.map((tagItem) => {
						if (tagItem.engagementTagId === action.payload.tagId) {
							tagItem.tagReferences.push(newTagReference);
						}
						return tagItem;
					});
					return {
						...state,
						data: tagList
					};
				}

				if (action.payload.operation === reducerOperations.Remove) {
					let tagList = newState.data.map((tagItem) => {
						if (tagItem.engagementTagId === action.payload.tagId) {
							tagItem.tagReferences = tagItem.tagReferences.filter(
								(entity) => entity.entityUIId !== action.payload.entityUIId
							);
						}
						return tagItem;
					});
					return {
						...state,
						data: tagList
					};
				}
			}

			return state;
		default:
			return state;
	}
}
